export default "__VITE_ASSET__CIUEDYKM__"